import { useMemo } from 'react';

import { t } from 'state/intl/translations';

import { ActionStatus, FormStatus } from '../types';

type GetFormStatus = {
  status: ActionStatus;
  createAddressView: boolean;
  showDeliveryAddresses: boolean;
  addressBeingEdited: boolean;
};
const getFormStatus = ({
  status,
  createAddressView,
  showDeliveryAddresses,
  addressBeingEdited,
}: GetFormStatus) => {
  const formStatus = FormStatus.Select;

  if (status === ActionStatus.QUOTE_UNAVAILABLE && showDeliveryAddresses) {
    return FormStatus.Unavailable;
  }
  if (createAddressView || !showDeliveryAddresses) {
    return addressBeingEdited ? FormStatus.Edit : FormStatus.Add;
  }

  return formStatus;
};

export const useHeaderTitle = ({
  status,
  createAddressView,
  showDeliveryAddresses,
  addressBeingEdited,
  showTermsView,
}: GetFormStatus & {
  status: ActionStatus;
  createAddressView: boolean;
  showDeliveryAddresses: boolean;
  addressBeingEdited: boolean;
  showTermsView: boolean;
}) => {
  return useMemo(() => {
    const formStatus = getFormStatus({
      status,
      addressBeingEdited,
      showDeliveryAddresses,
      createAddressView,
    });

    if (showTermsView) {
      return t('deliveryTermsHeading');
    }

    if (formStatus === FormStatus.Unavailable) {
      return t('deliveryNotAvailable');
    }

    if (formStatus === FormStatus.Edit) {
      return t('editAddress');
    }

    if (formStatus === FormStatus.Add) {
      return t('deliveryAddNewAddress');
    }

    return t('deliverySelectYourAddress');
  }, [addressBeingEdited, createAddressView, showDeliveryAddresses, showTermsView, status]);
};
